<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="fill-current"
    viewBox="0 0 16 12"
  >
    <path
      d="M1.69978 4.57136C1.30525 4.18488 0.672119 4.19141 0.285641 4.58593C-0.100836 4.98046 -0.0943092 5.6136 0.30022 6.00007L1.69978 4.57136ZM5.8125 10L5.11272 10.7144L5.8125 11.3999L6.51228 10.7144L5.8125 10ZM15.6998 1.71436C16.0943 1.32788 16.1008 0.69475 15.7144 0.30022C15.3279 -0.0943092 14.6947 -0.100836 14.3002 0.285641L15.6998 1.71436ZM0.30022 6.00007L5.11272 10.7144L6.51228 9.28564L1.69978 4.57136L0.30022 6.00007ZM6.51228 10.7144L15.6998 1.71436L14.3002 0.285641L5.11272 9.28564L6.51228 10.7144Z"
    />
  </svg>
</template>
